import {
  isRequired,
  isNonEmptyArray,
  isDate,
  isISODate,
  type Validation,
} from './utils';

const validations: Validation[] = [
  ({ trackingNumber }) => isRequired(trackingNumber) || { trackingNumber: 'Tracking number is required. ' },
  ({ shipper }) => isRequired(shipper) || { shipper: 'Shipper is required.' },
  ({ shipDate }) => isDate(shipDate) || isISODate(shipDate) || { shipDate: 'Ship date should be a valid ISO date string.' },
  ({ barcodeItems }) => isNonEmptyArray(barcodeItems) || { barcodeItems: 'Please select at least one item to ship.' },
];

const KEYS = [
  'trackingNumber',
  'shipper',
  'shipDate',
  'barcodeItems',
];

export {
  validations,
  KEYS,
};
